import { Anchor, Center, Divider, Paper, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";
import { HOST, PUBLIC_URL } from "../../utils/const";
import { useTranslation } from "react-i18next";


export const ScheduleConfirmed = ({ bookingId }: { bookingId: string }) => {
    const { t } = useTranslation(['app']);

    return <Center>
        <Paper bg="white.0" p={48} withBorder my="xl" radius="xl">
            <Title order={1} fz={"calc(16px + 1.8vw)"}>
                {t('schedule.confirmed.title')}
            </Title>
            <Text fz={"calc(12px + 1.2vw)"}>
                {t('schedule.confirmed.email-notice')}
            </Text>
            <Text fz={"calc(12px + 1.2vw)"}>
                {t('schedule.confirmed.view-update')} <a href={`${HOST}${PUBLIC_URL}/book?booking_uuid=${bookingId}`}>{t('common.here')}</a>.
            </Text>

            <Divider my="lg" />

            <Stack gap="4">
                <Text>Join <Anchor href={HOST} target="_blank">Calensync</Anchor> for free and:</Text>
                <Text>
                    🗓️ create you own availability schedule to seamlessly book meetings
                </Text>
                <Text>
                    🔄 Synchronize your Google, Outlook, Apple, or iCalendar calendars for you and your team
                </Text>
            </Stack>
        </Paper>
    </Center>;
}
